import { MdOutlineRemoveRedEye } from "react-icons/md";
import { FcGoogle } from "react-icons/fc";
import coupleImg from "../../Assets/SignUp/coupleImg.jpeg";
import absolute from "../../Assets/SignUp/absolute.png";
import bg from "../../Assets/SignUp/bg.png";
import heading from "../../Assets/SignUp/heading.png";
import { FaRegEyeSlash } from "react-icons/fa";
import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userRegister } from "../../Redux/Actions/AuthAction";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import useTitle from "../../Hooks/useTitle";
import couple1 from "../../Assets/review/db2.jpg"

const SignUp = () => {
  useTitle('Sign Up')
  const [showPassword, setShowPassword] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: ""
  });

  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.Auth);

  const handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev, [name]: value
    }))
  }

  const handleTermsChange = (e) => {
    setAcceptedTerms(e.target.checked);
  }

  const handleSignUp = async (e) => {
    e.preventDefault();
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!formData.firstname || !formData.lastname || !formData.email || !formData.password) {
      return toast.error('All fields are Required !!')
    } else if (!regex.test(formData.email)) {
      return toast.error('Enter valid Email')
    } else if (!acceptedTerms) {
      return toast.error('Please accept Terms & Conditions and Privacy Policy')
    }

    try {
      await dispatch(userRegister(formData))
      navigate('/personal-details');
    } catch (error) {
      if (error?.response?.data?.errors) {
        const key = error?.response?.data?.errors;
        const firstField = Object.keys(key)[0];
        if (firstField && key[firstField].length > 0) {
          return toast.error(key[firstField][0]);
        }
      } else {
        return toast.error(error.response.data.message);
      }
    }
  }

  const handleGoogleLogin = () => {
    const base_url = process.env.REACT_APP_BASE_API_URL;
    window.location.href = `${base_url}/auth/google`; // Laravel route
  };

  // Check if form is valid and terms are accepted
  const isFormValid = formData.firstname && 
                     formData.lastname && 
                     formData.email && 
                     formData.password && 
                     acceptedTerms;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 lg:h-screen lg:overflow-hidden">
      {/* Left Side Image */}
      <div className="hidden lg:block relative flex justify-center items-center p-4 lg:h-full lg:overflow-hidden">
        <div className="w-full lg:h-full relative">
          <img
            src={couple1}
            alt="Couple"
            className="w-full lg:h-full object-cover rounded-xl"
          />
          {/* Overlay Content */}
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 text-center text-white">
            <img src={absolute} alt="Decorative Icon" className="mx-auto mb-2" />
            <h1 className="text-3xl font-bold">USA</h1>
            <h2 className="text-3xl font-bold">Gujarati Community</h2>
          </div>
        </div>
      </div>

      {/* Right Side Form */}
      <div
        className="flex items-center justify-center lg:h-full lg:overflow-hidden"
        style={{
          backgroundImage: `url(${bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="max-w-xl w-full py-24 p-6 lg:h-full lg:flex lg:flex-col lg:justify-center ">
          <div className="flex justify-center">
            <img src={heading} alt="Matrimony" className="h-12 w-32" />
          </div>
          <h2 className="text-center text-2xl font-semibold py-3">Welcome!</h2>

          <form className="flex flex-col " onSubmit={handleSignUp}>
            {/* Name Section */}
            <label className="block font-medium mb-1">Your Name</label>
            <div className="grid grid-cols-2 gap-4">
              <input
                type="text"
                name="firstname"
                value={formData.firstname}
                onChange={handleChange}
                placeholder="First Name"
                className="p-3 border border-[#D5D7DA] rounded-xl w-full focus:outline-none focus:ring-2 focus:ring-[#E72848] shadow-[0px_1px_2px_0px_#0A0D120D]"
              />
              <input
                type="text"
                name="lastname"
                value={formData.lastname}
                onChange={handleChange}
                placeholder="Last Name"
                className="p-3 border border-[#D5D7DA] rounded-xl w-full focus:outline-none focus:ring-2 focus:ring-[#E72848] shadow-[0px_1px_2px_0px_#0A0D120D]"
              />
            </div>

            {/* Email Section */}
            <label className="block font-medium mt-2 mb-1">Email ID</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email id"
              className="w-full p-3 border border-[#D5D7DA] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#E72848] shadow-[0px_1px_2px_0px_#0A0D120D]"
            />

            {/* Password Section */}
            <label className="block font-medium mt-2 mb-1">Password</label>

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full p-3 border border-[#D5D7DA] rounded-xl focus:outline-none focus:ring-2 focus:ring-[#E72848] shadow-[0px_1px_2px_0px_#0A0D120D]"
                placeholder="Enter your password"
              />
              <span
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaRegEyeSlash size={20} /> : <MdOutlineRemoveRedEye size={22} />}
              </span>
            </div>

            {/* Terms & Conditions */}
            <div className="flex items-start mt-2 flex-col sm:flex-row sm:items-center">
              <div className="flex items-start sm:items-center">
                <input 
                  type="checkbox" 
                  className="mr-2 w-4 h-4 mt-1 sm:mt-0" 
                  checked={acceptedTerms}
                  onChange={handleTermsChange}
                />
                <span className="text-sm text-gray-700">
                  I agree to the
                  <span
                    className="text-[#E72848] font-semibold mx-1 cursor-pointer"
                    onClick={() => console.log('handle function for Terms & Conditions')}
                  >
                    Terms & Conditions
                  </span>
                  and
                  <span
                    className="text-[#E72848] font-semibold ml-1 cursor-pointer"
                    onClick={() => console.log('handle function for Privacy Policy')}
                  >
                    Privacy Policy
                  </span>
                  .
                </span>
              </div>
            </div>

            {/* Sign-Up Button */}
            <div className="py-3">
              <button
                type="submit"
                className={`w-full text-white p-3 flex justify-center rounded-xl font-semibold transition duration-300 ${
                  isFormValid && !loading
                    ? "bg-[#E72848] hover:bg-[#f53b58] cursor-pointer"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
                disabled={!isFormValid || loading}
              >
                {
                  loading ? <CircularProgress size={24} color="inherit" /> : "Sign Up"
                }
              </button>
            </div>

            {/* OR Separator */}
            <div className="flex items-center my-2">
              <hr className="flex-grow border-gray-300" />
              <span className="px-3 text-gray-600">or</span>
              <hr className="flex-grow border-gray-300" />
            </div>

            {/* Google Sign-Up */}
            <button
              type="button"
              className="w-full flex justify-center items-center border border-gray-300 p-3 rounded-xl hover:bg-gray-100 transition duration-300 cursor-pointer"
              onClick={handleGoogleLogin}
            >
              <FcGoogle size={26} className="mr-2" />
              <span className="font-bold text-black">Sign Up with Google</span>
            </button>

            <p className="text-center mt-2 text-sm">
              Have an account?
              <NavLink to="/signin" className="text-[#E72848] font-semibold ml-1">
                Log In
              </NavLink>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SignUp;